import { faCalendarAlt, faCreditCard, faUser } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Button, Card, CardActionArea, CardContent, CardHeader, Grid, Hidden, InputAdornment, makeStyles, TextField, Typography } from '@material-ui/core';
import clsx from 'clsx';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import Cards from 'react-credit-cards';
import "react-credit-cards/es/styles-compiled.css";
import { Helmet } from 'react-helmet';
import InputMask from 'react-input-mask';
import { createNewCCPaymentMethod, getNewCCPaymentToken } from 'services/payments.service';
import { getCardIcon } from 'util/creditCard';
import { useTrackEvent } from 'util/trackEvent';
import { DRAWER_WIDTH } from '../Stepper/Sidebar';
import { Alert } from '@material-ui/lab';
// import AdyenEncrypt from 'src/lib/adyen.encrypt.nodom.min.js'


const useStyles = makeStyles((theme) => {
  return {
    paymentDisabled: {
      color: theme.palette.text.disabled,
    },
    padded: {
      marginRight: theme.spacing(2),
    },
    input: {
      marginBottom: theme.spacing(1),
    },
    actions: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
      '& > *': {
        marginLeft: theme.spacing(2),
      }
    },
    cardIcon: {
      width: '3rem',
      height: '3rem',
      borderRadius: 3,
    }
  }
})
const CreateCardForm = ({ 
  onSuccess = () => { },
  onEnterCreateMode = () => { },
  onExitCreateMode = () => { },
}) => {
  const classes = useStyles()

  const formSetup = useMemo(() => {
    return {

    }
  }, []);

  const [number, setNumber] = useState('')
  const [name, setName] = useState();
  const [expiry, setExpiry] = useState();
  const [cvc, setCvc] = useState();
  const [focused, setFocused] = useState();
  const [formData, setFormData] = useState();

  const [displayCreate, setDisplayCreate] = useState(true);

  const [cardParams, setCardParams] = useState();

  const [newCard, setNewCard] = useState();

  const [error, setError] = useState(null);
  const trackEvent = useTrackEvent()
  const handleInputFocus = ({ target }) => {
    setFocused(target.id);
    setError(null)
  };

  const handleSubmit = useCallback(
    async () => {
      setError(null)
      const token = await getNewCCPaymentToken()
      const adyenInstance = window?.adyen
      if (!adyenInstance) {
        return alert('Adyen not available')
      }
      let encrypteddata = ''
      try {
        const encrypt = adyenInstance.encrypt.createEncryption(token?.token, {
          enableValidations:true,
          fourDigitCvcForBins: '34,37'
        })

        const generationtime = new Date().toISOString()
        const [month, year] = expiry.split('/')
        const cardData = {
          number,
          holderName: name,
          cvc,
          expiryMonth: month,
          expiryYear: `20${year}`,
          generationtime,
        }
        encrypteddata = encrypt.encrypt(cardData)
        const newPaymentParams = {
          label: 'Personal',
          is_default: 0,
          nonce: encrypteddata
        }
        const results = await createNewCCPaymentMethod(newPaymentParams)
        setDisplayCreate(true)
        onSuccess()
      }
      catch (e) {
        console.log("📢[CreateCardForm.jsx:84]: ", e);
        setError(e?.message?.en || e?.response?.data?.message?.en || e?.response?.data?.details)
      } finally {
        setCardParams({ encrypteddata })
      }
    },
    [cvc, expiry, name, number, onSuccess],
  );

  const handleCallback = useCallback(
    ({ issuer }, isValid) => {

    },
    [],
  );

  useEffect(
    () => {
      if(displayCreate) {
        setNumber('')
        setName('')
        setExpiry()
        setCvc()
      }
      if (!displayCreate) {
        onEnterCreateMode()
      } else {
        onExitCreateMode()
      }
    }, [displayCreate]
  );

  useEffect(
    () => {
      setError(null)
    }, [name, number, expiry, cvc]
  );

  if (displayCreate) {
    return (
      <>
        <Helmet>
          <script src="/lib/adyen.encrypt.js"></script>
        </Helmet>

        <Grid container className={clsx(classes.padded, classes.root)}>
          <Grid item xs={12} md={6}>
            <CardActionArea onClick={() => {
              trackEvent('Payment - click Add Debit/Credit', {})
              setDisplayCreate(false)
            }}>
              <CardHeader avatar={
                <img className={classes.cardIcon} src={getCardIcon('card')} alt='credit/debit' />
              } title="Add Debit/Credit" />
            </CardActionArea>
          </Grid>
          <Grid item xs={12} md={6}>
            {/* <CardActionArea disabled>
              <CardHeader className={classes.paymentDisabled} avatar={
                <img className={classes.cardIcon} src={getCardIcon('paypal')} alt={'paypal'} />
              } title="Login to paypal" />
            </CardActionArea> */}
          </Grid>
        </Grid>

      </>
    )
  }


  return (
    <>
      <CardHeader title="Add a new card"/>
      <CardContent>
        <Grid container>
          <Grid item xs={12} md={6}>
            <InputMask
              mask="9999 9999 9999 9999"
              value={number}
              onChange={(e) => setNumber(e.target.value)}
              disabled={false}
              maskChar=" "
            >
              {() => (
                <TextField
                  className={classes.input}
                  variant="outlined"
                  size="small"
                  id="number"
                  fullWidth
                  label="Card Number"
                  onFocusCapture={handleInputFocus}
                  InputProps={{
                    startAdornment: <InputAdornment position="start"><FontAwesomeIcon icon={faCreditCard} /></InputAdornment>,
                  }}
                />
              )}
            </InputMask>

            <TextField
              className={classes.input}
              variant="outlined"
              size="small"
              id="name"
              fullWidth
              label="Cardholder Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              onFocusCapture={handleInputFocus}
              InputProps={{
                startAdornment: <InputAdornment position="start"><FontAwesomeIcon icon={faUser} /></InputAdornment>,
              }}
            />
            <Grid container spacing={1} >
              <Grid item xs={6}>

                <InputMask
                  mask="99/99"
                  value={expiry}
                  onChange={(e) => setExpiry(e.target.value)}
                  disabled={false}
                  maskChar=" "
                >
                  {() => (
                    <TextField
                      className={classes.input}
                      variant="outlined"
                      size="small"
                      id="expiry"
                      fullWidth
                      label="Valid Until"
                      onFocusCapture={handleInputFocus}
                      InputProps={{
                        startAdornment: <InputAdornment position="start"><FontAwesomeIcon icon={faCalendarAlt} /></InputAdornment>,
                      }}
                    />
                  )}
                </InputMask>
              </Grid>
              <Grid item xs={6}>
                <InputMask
                  mask="9999"
                  value={cvc}
                  onChange={(e) => setCvc(e.target.value)}
                  disabled={false}
                  maskChar=""
                >
                  {() => (
                    <TextField
                      className={classes.input}
                      variant="outlined"
                      size="small"
                      id="cvc"
                      fullWidth
                      label="CVC"
                      onFocusCapture={handleInputFocus}
                      InputProps={{
                        
                      }}
                    />
                  )}
                </InputMask>
              </Grid>
            </Grid>
            {error && <Alert severity="error">{error}</Alert>}
            <div className={classes.actions}>
              <Button onClick={() => {
                trackEvent('Payment - Create Card - click Cancel', {})
                setDisplayCreate(true)
              }}
                variant="outlined">Cancel
              </Button>
              <Button onClick={() => {
                trackEvent('Payment - Create Card - click Add Card', {})
                handleSubmit()
              }} variant="contained" color="primary">Add Card</Button>
            </div>
          </Grid>
          <Grid item xs={12} md={6} >
            <Hidden xsDown>
              <Cards
                number={number}
                name={name}
                expiry={expiry}
                cvc={cvc}
                focused={focused}
                callback={handleCallback}
              />
            </Hidden>
          </Grid>
        </Grid>
      </CardContent>

    </>
  )
}

export { CreateCardForm };
